
import React, {useEffect, useState} from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';
import LoftyEditorJsReadOnly from '../../components/LoftyEditorJsReadOnly';
import LoftyEditorJs from '../../components/LoftyEditorJs';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {createcontactdata } from '../../api/contactdata.api'

import './contactpage.scss';








const Pcontactpage = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {



useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);



  
  
  
  

  
  return (
    <div id="id68c49b138e5aed52dc7e12d1" >

      <div id="i9ol" className="">
      
      <div id="icjbu5" className="">
      
        <a
          target=""
          className=""
          id="i88pyl"
          href={`/`}
        >
          
      <img
        className=""
        id="iwbvf5"
        src="https://assetsprojects.s3.amazonaws.com/404pziimfhcxkni.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      <div id="ipwig4" className="">
      
        <a
          target=""
          className=""
          id="ix4dgd"
          href="/estudios"
        >
          
    <div id="ivlyis" className="">
    <>Estudios</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ivw47x"
          href="#"
        >
          
    <div id="iv1mlt" className="">
    <>Contacto</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="iizt" className="">
      
      <div id="iwdy" className="">
      
      <div className="" id="i1hzn">
        <>Contacto</>
      </div>
      
      </div>
      
      </div>
      
      <div id="ifgm" className="">
      
      <div id="ihdlf" className="">
      
      <div className="" id="iekiw">
        <>Contacto</>
      </div>
      
      </div>
      
      <div id="isfsn" className="">
      
        <div className="" id="i71f24">
          
      <form
        id="i8lyx"
        className=""
        onSubmit={async (e) => {
				e.preventDefault();
				try {
						const lofty_response = await createcontactdata({
						token: 'aasdas',
						namecontact: e.target.namecontact?.value,
						emailcontact: e.target.emailcontact?.value,
						undefined: e.target.undefined?.value,
						messageinfo: e.target.messageinfo?.value,
					});
					alert("Sent!!");
		} catch (error) {
					console.log(error);
					if (error.info) {
						alert(error.info);
					}
				}
			}}
		
      >
        
      <div id="ilkik" className="">
      
      <label id="" className="">
      <>Nombre</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="namecontact"
        type="text"
        placeholder="Nombre"
        className="inputstyle "
        id="inhue"
      />
      
      </div>
      
      <div id="ig4pp" className="">
      
      <label id="" className="">
      <>Correo</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="emailcontact"
        type="text"
        placeholder="Correo"
        className="inputstyle "
        id="i5mslv"
      />
      
      </div>
      
    <div id="ik706z" className="">
    
      <label id="ijrjpi" className="">
      <>Mensaje</>
      </label>
      
      <br className="" id="" />
      
      <textarea name="messageinfo" className="inputstyle " id="i9iibx">
        
      </textarea>
      
    </div>
    
      <button
        type="submit"
        name=""
        id="id3s28"
        className=""
        
      >
      
      <div id="ic7871" className="">
      <>Enviar</>
      </div>
      
      </button>
      
      </form>
      
        </div>
        
      </div>
      
      </div>
      
      <div id="ii5t" className="">
      
      <div id="io6yi" className="">
      
      </div>
      
      <div id="iyvwk" className="">
      
      <div id="ivlb5" className="">
      
      <div id="iw4hc" className="">
      
      <div className="" id="i3df7">
        <>Seguimiento profesional</>
      </div>
      
      <div className="" id="i6pj8">
        <>Encuestas de alta frecuencia patentadas que le permiten ser el primero en saber cuándo cambia la opinión pública y la probabilidad de resultados políticos.</>
      </div>
      
        <a
          target=""
          className=""
          id="i3aw6g"
          href="#"
        >
          
      <span className="" id="iifyiy">
        <>Ver Mas</>
      </span>
      
        </a>
        
      </div>
      
      <img
        className=""
        id="iuyzc2"
        src="https://assetsprojects.s3.amazonaws.com/404pziime7ox3y3.jpg"
        alt="undefined"
      />
      
      </div>
      
      <div id="imwvvh" className="">
      
      <div id="iv9sr1" className="">
      
      <div className="" id="iin1ty">
        <>M2Global Monitor  </>
      </div>
      
      <div className="" id="ibz2nf">
        <>M2Global es una herramienta de inteligencia de redes sociales personalizable que proporciona un monitoreo granular de empresas, organizaciones, temas, campañas políticas, etc.</>
      </div>
      
        <a
          target=""
          className=""
          id="i00gff"
          href="#"
        >
          
      <span className="" id="id3vz7">
        <>Ver Mas</>
      </span>
      
        </a>
        
      </div>
      
      <img
        className=""
        id="icj4qn"
        src="https://assetsprojects.s3.amazonaws.com/404pziime7ox3y3.jpg"
        alt="undefined"
      />
      
      </div>
      
      <div id="inx1hy" className="">
      
      <div id="ijerzc" className="">
      
      <div className="" id="i8jk4i">
        <>Encuestas Públicas</>
      </div>
      
      <div className="" id="iu6t0x">
        <>Encuestas representativas a nivel nacional realizadas por M2Global   utilizando su tecnología patentada de recopilación de datos y algoritmos de post-estratificación.</>
      </div>
      
        <a
          target=""
          className=""
          id="in1c0v"
          href="#"
        >
          
      <span className="" id="iq2lzm">
        <>Ver Mas</>
      </span>
      
        </a>
        
      </div>
      
      <img
        className=""
        id="iif51w"
        src="https://assetsprojects.s3.amazonaws.com/404pziime7ox3y3.jpg"
        alt="undefined"
      />
      
      </div>
      
      <div id="itkdrg" className="">
      
      <div id="icg789" className="">
      
      <div className="" id="i8sspp">
        <>M2Global Político   </>
      </div>
      
      <div className="" id="ixdzez">
        <>M2Global Político    es una plataforma de transparencia política que empodera a los ciudadanos para exigir cuentas a sus políticos.</>
      </div>
      
        <a
          target=""
          className=""
          id="ilx2im"
          href="#"
        >
          
      <span className="" id="i5r0b4">
        <>Ver Mas</>
      </span>
      
        </a>
        
      </div>
      
      <img
        className=""
        id="idv40l"
        src="https://assetsprojects.s3.amazonaws.com/404pziime7ox3y3.jpg"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="id4e2" className="">
      
      <div className="" id="iglijz">
        <>Copyright © 2025 M2GlobalInsigths ORG</>
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pcontactpage);
  